import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { FormGroup, Validators } from '@angular/forms';
import { NavbarService } from 'src/app/service/navbar.service';
import { NotificationService } from 'src/app/service/notification.service';
import { UserService } from 'src/app/service/user.service';
import { User } from 'src/app/model/user';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthService } from 'src/app/service/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { RecaptchaComponent } from 'ng-recaptcha';
import { MathCaptchaComponent } from '../math-captcha/math-captcha.component';

export class DialogData {
  disabledNotification: boolean;
}

@Component({
  selector: 'app-dialog-create-user',
  templateUrl: './dialog-create-user.component.html',
  styleUrls: ['./dialog-create-user.component.scss']
})
export class DialogCreateUserComponent implements OnInit {
  public newUserForm: FormGroup;
  private userCreated: User;

  public captchaResolved: boolean = false;
  // @ViewChild(RecaptchaComponent) captchaRef: RecaptchaComponent;
  @ViewChild(MathCaptchaComponent) private captchaRef: MathCaptchaComponent;

  constructor(
    public dialogRef: MatDialogRef<DialogCreateUserComponent>,
    private fb: FormBuilder,
    public navbarService: NavbarService,
    private notificationService: NotificationService,
    private userService: UserService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private authService: AuthService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    this.newUserForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      lastName: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  public createUser(): void {
    if (this.newUserForm.valid) {
      this.navbarService.loadingStart();

      const fullName = `${this.newUserForm.value.firstName} ${this.newUserForm.value.lastName}`;

      if (!this.data?.disabledNotification) this.notificationCreatedUser(fullName);

      this.userService.createUserIgnoreErrorHandling(this.newUserForm.value).subscribe({
        next: (user) => {
          this.userCreated = user;
        },
        error: (e) => {
          if (e.error.status.params?.email === 'unique') {
            this.emailAlreadyExists();
          }
          this.navbarService.loadingStop();
        },
        complete: () => {
          this.navbarService.loadingStop();
          this.close(this.userCreated);
        }
      });
    }
  }

  private emailAlreadyExists(): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.data = { 
      title: 'errors.could-not-create-user',
      content: 'errors.email-already-exists',
      params: { onlyOkButton: true }
    };

    this.dialog.open(ConfirmationDialogComponent, dialogConfig);
  }

  public onCaptchaResolved() {
    this.captchaResolved = this.captchaRef.getStatus();

    // this.authService.validateCaptcha(token).subscribe(response => {
    //   this.captchaResolved = response.data.success;
    //   if (!this.captchaResolved) {
    //     this.captchaRef.reset();
    //     this.notificationService.notifyError(this.translateService.instant('forms.errors.invalid-recaptcha-token'));
    //   }
    // });
  }

  private notificationCreatedUser(fullName: string): void {
    const label = 'forms.creating-user';
    const params = { params: { user: fullName } };

    this.notificationService.notify(label, params);
  }

  public close(data = null): void {
    this.dialogRef.close(data);
  }

}
